import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import {
  DropDownNew,
  DropDownItem,
  IconLoad
} from '@Knowledge-OTP/znk-ui-components'
import { Badge } from 'reactstrap'
import { tagsTypeArray } from '../../../../../utils/getTagsType'
import { getTagTypeLabel } from '../../../../Constants/Utils/tagTypeLabel'
// import useGetAllTags from '../../../../Constants/Tags/Model/useGetAllTags'
import useAssignTagToStudent from '../../../../Constants/Tags/Model/AssignTag'
import './options-tags-badge.css'
import useTranslation from '../../../../../i18n/useTranslation'
import { showAlert } from '../../../../../common/Alert/util'

const OptionsTagsBadge = ({ loading, className = '', userData, refetch = () => { }, data }) => {
  // const [getAllTags, { data }] = useGetAllTags()
  const dispatch = useDispatch()
  const [groupedTagsByType, setGroupedTagsByType] = useState({})
  const [hoveredType, setHoveredType] = useState(null)
  const { translate } = useTranslation()
  const hadTagRef = useRef(false)
  const [AssignTagToStudent, { loading: assignTagLoading }] = useAssignTagToStudent(
            (resp) => {
              console.log(hasTag)
              refetch()
              if (!hadTagRef.current) {showAlert({
                text: translate('profile.modal.zinkerzTag.successMsg'),
                status: 'success'
              }, dispatch)
            }
            else {
               showAlert({
                text: translate('profile.modal.zinkerzTag.removeMsg'),
                status: 'success'
              }, dispatch)
              console.log("Zinkerz Camp actualizado correctamente")
            }
            },
            (err) => {
                showAlert({
                    text: translate('profile.modal.zinkerzTag.msgErr'), err,
                    status: 'error'
                }, dispatch)
                console.error("Error al marcar Zinkerz Camp:", err)
            }
  );
  const submenuRef = useRef(null)
  const setTagToStudent = async (tagId, studentId) => {
    if (assignTagLoading) return
    hadTagRef.current = hasTag(tagId)
    const variables = {
      tagId,
      studentId
    };
    await AssignTagToStudent({ variables })
  }

  /* =====================
     FETCH TAGS (1 sola vez)
  ===================== */
  // useEffect(() => {
  //   getAllTags()
  // }, [getAllTags])

  /* =====================
     GROUP TAGS BY TYPE
  ===================== */
  useEffect(() => {
    if (!data?.allTags?.docs) return

    const grouped = data.allTags.docs
      .filter(tag => tag.isActive === true)
      .reduce((acc, tag) => {
        if (!acc[tag.type]) acc[tag.type] = []
        acc[tag.type].push(tag)
        return acc
      }, {})

    setGroupedTagsByType(grouped)
  }, [data])

  /* =====================
     OPTIONS (TIPOS)
  ===================== */
  const options = tagsTypeArray.map(type => ({
    type,
    title: getTagTypeLabel(type),
  }))

  const studentTags = userData?.studentInfo?.tags || []
  console.log(studentTags)
  const hasTag = (tagId) => studentTags.includes(tagId)

  return (
    <DropDownNew
      className={className}
      direction="bottomLeft"
      options={options.map(({ type, title }) => ({
        component: (
          <div
            key={type}
            className="znk-menu-item-wrapper"
            onMouseEnter={() => setHoveredType(type)}
            onMouseLeave={() => setHoveredType(null)}
          >
            <DropDownItem>
              <span className="submenu-label">
                {title}
                <span className="submenu-arrow">›</span>
              </span>
            </DropDownItem>

            {/* SUBMENU */}
            {hoveredType === type && (
              <div
                ref={submenuRef}
                className="znk-submenu"
              >
                {(groupedTagsByType[type] || []).map(tag => (
                  <div
                    key={tag.id}
                    className={`znk-submenu-item ${hasTag(tag.id) ? 'znk-submenu-item--active' : ''
                      }`}
                    onClick={() => {
                      setTagToStudent(tag.id, userData.id)
                      setHoveredType(null)
                    }}
                  >
                    {tag.name}
                  </div>

                ))}
              </div>
            )}
          </div>
        ),
      }))}
    >
      <div className="hover-icon znk-icon-action-modal">
        {loading ? (
          <IconLoad />
        ) : (
          <Badge className="badge badge-pill badge-empty d-flex align-items-center py-1 font-weight-bold">
            +
          </Badge>
        )}
      </div>
    </DropDownNew>
  )
}

export default OptionsTagsBadge
